import api from '@services/api'

export default {
  list(axios, params, query, config) {
    return api.get(axios, '/manager/categories', params, query, config)
  },

  get(axios, params, query, config) {
    return api.get(axios, '/manager/categories/:id', params, query, config)
  },

  create(axios, params, payload, config) {
    return api.post(axios, '/manager/categories', params, payload, config)
  },

  update(axios, params, payload, config) {
    return api.update(axios, '/manager/categories/:id', params, payload, config)
  },

  destroy(axios, params, config) {
    return api.delete(axios, '/manager/categories/:id', params, config)
  },

  searchParent(axios, params, query, config) {
    return api.get(axios, '/manager/categories/search_parent', params, query, config)
  },
}
